import { render, staticRenderFns } from "./NavigationContent.vue?vue&type=template&id=0b04865a&scoped=true&"
import script from "./NavigationContent.vue?vue&type=script&lang=js&"
export * from "./NavigationContent.vue?vue&type=script&lang=js&"
import style0 from "./NavigationContent.vue?vue&type=style&index=0&id=0b04865a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b04865a",
  null
  
)

export default component.exports